import { Button, DuplicateIcon } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { copyTextToClipboard } from '../../../utils/copyTextToClipboard';
import { useTimetableStore } from '../TimetableProvider';

/**
 * Kopiert die rohe Timefold-Analyze-Antwort (JSON) in die Zwischenablage — zum Teilen
 * der Rohdaten beim Debuggen/Feintunen. Rendert nichts, solange keine Analyse vorliegt.
 */
export const CopyRawAnalysisButton: FC<{ className?: string | undefined }> = observer(({ className }) => {
  const { t } = useTranslation();
  const pinboardStore = useTimetableStore();
  const [copied, setCopied] = useState(false);
  const resetTimer = useRef<number | null>(null);

  useEffect(
    () => () => {
      if (resetTimer.current !== null) window.clearTimeout(resetTimer.current);
    },
    [],
  );

  const result = pinboardStore.timefoldAnalyzeModal.result;
  if (result == null) {
    return null;
  }

  const handleCopy = async () => {
    let text: string;
    try {
      text = JSON.stringify(result, null, 2);
    } catch {
      text = String(result);
    }
    await copyTextToClipboard(text);
    setCopied(true);
    if (resetTimer.current !== null) window.clearTimeout(resetTimer.current);
    resetTimer.current = window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Button
      className={className}
      hierarchy='secondary'
      icon={<DuplicateIcon className='small' />}
      onClick={() => void handleCopy()}
      type='button'
    >
      {copied ? t('pinboard.timefoldAnalyze.copyRawDone') : t('pinboard.timefoldAnalyze.copyRaw')}
    </Button>
  );
});

CopyRawAnalysisButton.displayName = 'CopyRawAnalysisButton';
